// ** React Imports
import ReactDOM from "react-dom";
import { Suspense, lazy } from "react";
import { HashRouter } from "react-router-dom";
// ** Redux Imports
import { store } from "./redux/store";
import { Provider } from "react-redux";

// ** GraphQL
// import { ApolloLink, HttpLink } from "apollo-boost";
import { ApolloProvider, ApolloClient, InMemoryCache, ApolloLink, HttpLink } from "@apollo/client";
import Cookies from "js-cookie";

// ** Intl, CASL & ThemeColors Context
import ability from "./configs/acl/ability";
import { AbilityContext } from "./utility/context/Can";
import { ThemeContext } from "./utility/context/ThemeColors";

// ** ThemeConfig
import themeConfig from "./configs/themeConfig";

// ** Toast
import { Toaster } from "react-hot-toast";

// ** i18n
import "./configs/i18n";

// ** Spinner (Splash Screen)
import Spinner from "./@core/components/spinner/Fallback-spinner";

// ** Ripple Button
import "./@core/components/ripple-button";

// ** Fake Database
import "./@fake-db";

// ** PrismJS
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import "prismjs/components/prism-jsx.min";

// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";

// ** React Hot Toast Styles
import "@styles/react/libs/react-hot-toasts/react-hot-toasts.scss";

// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css";
import "./@core/scss/core.scss";
import "./assets/scss/style.scss";
import "./vyrillTheme.scss";

// ** Service Worker
import * as serviceWorker from "./serviceWorker";
import ServerMessages from "./Shared/ServerMessages/ServerMessages";

// ** Google ClientID
import { GoogleOAuthProvider } from "@react-oauth/google";

// ** Mixpanel
import mixpanel from "mixpanel-browser";
import PopUpModals from "./Shared/PopUpModals";
mixpanel.init(`${process.env.REACT_APP_MIXPANEL_TOKEN}`, {
  debug: process.env.NODE_ENV === "development" || "staging",
  ignore_dnt: process.env.NODE_ENV === "development" || "staging",
});

const httpLink = new HttpLink({
  uri: `${process.env.REACT_APP_GRAPHQL_URL}`,
});

const authLink = new ApolloLink((operation, forward) => {
  // Retrieve the authorization token from Cookies.
  const token = Cookies.get("jwt");

  // Use the setContext method to set the HTTP headers.
  operation.setContext({ headers: { authorization: `Bearer ${token}` } });

  // Call the next link in the middleware chain.
  return forward(operation);
});

const client = new ApolloClient({
  link: authLink.concat(httpLink), // Chain it with the HttpLink
  cache: new InMemoryCache(),
});

// ** Lazy load app
const LazyApp = lazy(() => import("./App"));

// Set header in API calls
$.ajaxSetup({ headers: { Authorization: `Bearer ${Cookies.get("jwt")}` } });

ReactDOM.render(
  <Provider store={store}>
    <Suspense fallback={null}>
      <AbilityContext.Provider value={ability}>
        <ApolloProvider client={client}>
          <GoogleOAuthProvider
            clientId={`${process.env.REACT_APP_GOOGLE_CLIENT_ID_SIGNUP}`}
          >
            <ThemeContext>
              <HashRouter>
                <ServerMessages />
                <PopUpModals />
                <LazyApp />
                <Toaster
                  position={themeConfig.layout.toastPosition}
                  toastOptions={{ className: "react-hot-toast" }}
                />
              </HashRouter>
            </ThemeContext>
          </GoogleOAuthProvider>
        </ApolloProvider>
      </AbilityContext.Provider>
    </Suspense>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
